export default __webpack_public_path__ + "static/media/gallery_00.af4f0979.jpg";